import React from 'react';

// eslint-disable-next-line import/no-cycle
import UserCardsList from './UserCardsList';

const ProfileSettings = () => <UserCardsList />;

export default ProfileSettings;
